import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {ProductDetailApi, ProductDetailDto} from "../../api";
import ProductDetailsList from "./productDetailList";
import ProductDetailModalFormAddContainer from "./productDetailModalForm/productDetailModalFormContainer";
import Title from "antd/es/typography/Title";
import {useParams} from "react-router-dom";
import {Layout} from "antd";
import {Content} from "antd/es/layout/layout";
import ProductStatisticsListContainer from "../productStatistics/productStatisticsListContainer";
import TagsListContainer from "../tag/tagListContainer";

export default function ProductDetailsListContainer() {
    const apiService = useInjection(ApiService);
    const [productDetails, setProductDetails] = useState<ProductDetailDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [productDetailModalFormContainerTitle, setProductDetailModalFormContainerTitle] = useState<string>();
    const [idProductDetailToEdit, setIdProductDetailToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>();
    let {productId} = useParams();

    const refreshProductDetailsList = useCallback(async () => {
        setIsLoading(true);

        try {
            const productDetails = await apiService.getApi(ProductDetailApi)
                .apiProductDetailProductDetailsProductIdGet(+productId!);

            setProductDetails(productDetails.data);
        } catch (e: any) {
            console.log(e.response.data);
        } finally {
            setIsLoading(false);
        }
    }, [apiService, productId]);

    const onAddClicked = () => {
        setProductDetailModalFormContainerTitle("Dodaj nową sekcję");
        setIdProductDetailToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = (id: number) => {
        setProductDetailModalFormContainerTitle(`Edytuj sekcję: ${id}`);

        setIsLoading(true);
        setIdProductDetailToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(ProductDetailApi).apiProductDetailIdDelete(id)

        if (response.request.status !== 200) {
            console.log("Error occured while deleting data");
        } else {
            refreshProductDetailsList();
        }
    }

    const onFinish = async (shouldRefresh: boolean) => {

        setAddFormVisible(false);

        if (shouldRefresh) {
            refreshProductDetailsList();
        } else {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        refreshProductDetailsList();
    }, [refreshProductDetailsList]);

    return <Layout style={{backgroundColor: "white"}}>
        <Content style={{padding: 20}}>
            <Title>Szczegółowy opis: </Title>
            <ProductDetailsList
                data={productDetails || null}
                onAddClicked={onAddClicked}
                onEditClicked={onEditClicked}
                onDeleteClicked={onDeleteClicked}
                isLoading={isLoading}
            />
            <ProductDetailModalFormAddContainer
                onFinish={onFinish}
                id={idProductDetailToEdit}
                addFormVisibility={isAddFormVisible}
                title={productDetailModalFormContainerTitle || ""}
            />
            <ProductStatisticsListContainer/>
            <TagsListContainer/>
        </Content>
    </Layout>
}
